import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import supabase from '../config/supabaseClient';
import '../components/eventviewer.css';
import { useNavigate } from 'react-router-dom';
import EventChat from './eventchat';
import { usePassport } from '../passport';
import Handshake from './handshake';
import BuddyIcon from '../icons/buddyicon';
import SettingsIcon from '../icons/settingsicon';
import DashboardIcon from '../icons/dashboardicon';
import GuestListIcon from '../icons/guestlisticon';
import GuestTable from './guesttable';
import EditEventIcon from '../icons/editeventicon';
import QRCodeIcon from '../icons/qrcodeicon';
import { QRCodeSVG } from 'qrcode.react';
import RsvpIcon from '../icons/rsvpicon';
import RequestsIcon from '../icons/requestsicon';
import IgnoreIcon from '../icons/ignoreicon';
import ShowIgnoreIcon from '../icons/showignoreicon';
import SmerkIcon from '../icons/smerkicon';
import CloseIcon from '../icons/closeicon';
import SendInviteIcon from '../icons/sendinviteicon';
import { sendInvite } from '../utils/sendInvite';
import { normalizeEvent } from '../utils/normalizeevent';



function RSVPBlock({ eventId, userId }) {
  const [status, setStatus] = useState('');
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const loadRSVP = async () => {
      const { data, error } = await supabase
        .from('guests')
        .select('status, guest_comments')
        .eq('event_id', eventId)
        .eq('guest_id', userId)
        .single();

      if (data) {
        setStatus(data.status || '');
        setComment(data.guest_comments || '');
      } else if (error) {
        console.error('Error loading RSVP:', error);
      }

      setLoading(false);
    };

    loadRSVP();
  }, [eventId, userId]);

  const handleSubmit = async () => {
    setSaving(true);
    const { error } = await supabase
      .from('guests')
      .update({
        status,
        guest_comments: comment,
      })
      .eq('event_id', eventId)
      .eq('guest_id', userId);

    if (error) {
      console.error('Error saving RSVP:', error);
      setMessage('❌ Failed to save RSVP.');
    } else {
      setMessage('✅ RSVP saved!');
    }

    setSaving(false);
    setTimeout(() => setMessage(''), 3000);
  };

  if (loading) return <p>Loading RSVP info…</p>;

  return (
    <div className="rsvp-block" style={{ marginBottom: '1rem' }}>
      <h3>RSVP</h3>
      <div className="rsvp-options">
        {['Going', 'Maybe', 'Not Going'].map((opt) => (
          <label key={opt} style={{ marginRight: '15px' }}>
            <input
              type="radio"
              value={opt}
              checked={status === opt}
              onChange={() => setStatus(opt)}
            />
            {opt}
          </label>
        ))}
      </div>
      <textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder="Leave a note (optional)..."
        rows={3}
        style={{ width: '100%', marginTop: '10px' }}
      />
      <button onClick={handleSubmit} disabled={saving} style={{ marginTop: '10px' }}>
        {saving ? 'Saving…' : 'Submit RSVP'}
      </button>
      {message && <p style={{ marginTop: '8px' }}>{message}</p>}
    </div>
  );
}


export default function EventViewer({ event: externalEvent = null, setIsEditing = () => {},
  requestInviteShowContactModal,
  setRequestInviteShowContactModal, externalUser = null,}) {

  const { id: eventIdFromUrl } = useParams();
  const eventId = externalEvent?.id || eventIdFromUrl;
  const [internalShowContactModal, setInternalShowContactModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showRSVPModal, setShowRSVPModal] = useState(false);
  const [showJoinRequestModal, setShowJoinRequestModal] = useState(false);
  const [showGuestTable, setShowGuestTable] = useState(false);
  const [qrToken, setQrToken] = useState(null);
  const navigate = useNavigate();
  const passport = usePassport();
  const user = externalUser || passport.user;
  const profile = passport.profile;
  const passportLoading = passport.loading;
  const [event, setEvent] = useState(normalizeEvent(externalEvent));
  const [loading, setLoading] = useState(true);
  const [showQRModal, setShowQRModal] = useState(false);
  const [contactName, setContactName] = useState('');
  const [contactMessage, setContactMessage] = useState('');
  const [contactSocials, setContactSocials] = useState('');
  const isOwner = Boolean(user?.id && event?.host_id && user.id === event.host_id);
  const [viewerRole, setViewerRole] = useState(null);
  const [showRequestsModal, setShowRequestsModal] = useState(false);
  const [hasPendingRequests, setHasPendingRequests] = useState(false);
  const [joinRequests, setJoinRequests] = useState([]);
  const [hasNewJoinRequests, setHasNewJoinRequests] = useState(false);
  const [joinRequestCount, setJoinRequestCount] = useState(0);
  const [addAsGuestMap, setAddAsGuestMap] = useState({});
  const [guestPassphrases, setGuestPassphrases] = useState({});
  const [selectedRequestForSidebar, setSelectedRequestForSidebar] = useState(null);
  const [contactInfo, setContactInfo] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [errors, setErrors] = useState({ name: false, email: false, message: false });


      const [contactForm, setContactForm] = useState({
      name: '',
      social: '',
      message: '',
    });

        useEffect(() => {
  const fetchQRToken = async () => {
    if (!event || !user) return;

    if (user.id === event.host_id && event.host_qr_token) {
     setQrToken(`host_${event.host_qr_token}`);
    } else {
      const { data, error } = await supabase
        .from('guests')
        .select('guest_qr_token')
        .eq('event_id', event.id)
        .eq('guest_id', user.id)
        .single();

      if (data?.guest_qr_token) {
        setQrToken(data.guest_qr_token);
      } else {
        console.warn("No guest QR token found.");
      }
    }
  };

  fetchQRToken();
}, [event, user]);


const sendGuestConfirmationEmail = async ({ name, email, passphrase }) => {
    
  console.log("📨 sendGuestConfirmationEmail() called");
  console.log("➡️ Email:", email);
  console.log("➡️ Name:", name);
  console.log("➡️ Passphrase:", passphrase);
  
  try {
    const payload = {
      to: email,
      name,
      eventTitle: event.event_name,
      passphrase,
      vrc: event.vrc,
      moderatorContact: event.moderator_contact,
      link: `${window.location.origin}/event/${event.id}`,
    };

    const responseText = await sendInvite(payload);
    console.log('✅ Email sent successfully:', responseText);
  } catch (error) {
    console.error('❌ Failed to send invite:', error);
    alert('⚠️ Invite was approved, but the confirmation email failed.');
  }
};


  const handleApproveAndAddGuest = async (req) => {
    const passphrase = guestPassphrases[req.id]?.trim();
    const name = req.name?.trim();
    const email = req.email?.trim() || req.social_contact?.trim();

    // ✅ Basic input checks
    if (!name || !email || !passphrase) {
      alert('❌ Missing name, email/social, or passphrase. Cannot proceed.');
      return;
    }

    const nameParts = name.split(' ');
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '—';

    // ✅ Prevent duplicate guest entries
    const { data: existingGuests, error: checkError } = await supabase
      .from('guests')
      .select('id')
      .eq('event_id', event.id)
      .ilike('guest_first_name', firstName)
      .ilike('guest_last_name', lastName);

    if (checkError) {
      console.error('❌ Error checking for existing guest:', checkError);
      alert('⚠️ Something went wrong checking existing guests.');
      return;
    }

    if (existingGuests.length > 0) {
      alert('⚠️ This guest may already be added. Double-check the name.');
      return;
    }

    // ✅ Add new guest
    const guestEntry = {
      event_id: event.id,
      guest_first_name: firstName,
      guest_last_name: lastName,
      guest_id: null,
      invited_by: user?.id || null,
      vrc: event.vrc || '',
      passphrase,
      status: 'Coming',
      guest_qr_token: uuidv4(),
    };

    const { error: guestError } = await supabase.from('guests').insert([guestEntry]);

    if (guestError) {
      console.error('❌ Error adding guest:', guestError);
      alert('⚠️ Guest could not be added.');
      return;
    }

  const { error: updateError } = await supabase
    .from('event_requests')
    .update({
      status: 'approved',
      seen_by_host: true,
      approved_at: new Date().toISOString(), // ⏱️ new line
    })
    .eq('id', req.id);


    if (updateError) {
      console.error('❌ Error updating request:', updateError);
    }

    // ✅ Show success alert and update UI
    alert(`✅ ${name} added as guest.`);
    setJoinRequests(prev =>
      prev.map(r => r.id === req.id ? { ...r, __status: 'added' } : r)
    );

    await sendGuestConfirmationEmail({ name, email, passphrase });

    // ✅ Send confirmation email
    const { error: emailUpdateError } = await supabase
      .from('event_requests')
      .update({
        email_sent: true,
        email_sent_at: new Date().toISOString(),
      })
      .eq('id', req.id);

    if (emailUpdateError) {
      console.error('❌ Error updating email_sent flag:', emailUpdateError);
    }
  };


const handleContactSubmit = async () => {
  if (!event || !event.id) {
    alert("Missing event ID");
    return;
  }

      const hasError = {
      name: contactName.trim() === '',
      email: contactInfo.trim() === '',
      message: contactMessage.trim() === '',
    };

    if (hasError.name || hasError.email || hasError.message) {
      setErrors(hasError);
      return;
    }


  const { error } = await supabase.from('event_requests').insert([
    {
      event_id: event.id,
      user_id: user?.id || null,
      name: contactName,
      message: contactMessage,
      social_contact: contactSocials,
      status: 'pending',
      seen_by_host: false,
      email: contactInfo,
    }
  ]);

  if (error) {
    console.error('Error submitting request:', error);
    alert('❌ There was an error sending your message.');
  } else {
    alert('✅ Request sent to the host!');
    setContactName('');
    setContactMessage('');
    setContactSocials('');
    setShowContactModal(false);
  }
};



    const isLoggedIn = !!user;


    useEffect(() => {
      if (externalEvent?.id) {
        // Fetch full event details using the ID
        const fetchFullEvent = async () => {
          const { data, error } = await supabase
            .from('hosting')
            .select('*')
            .eq('id', externalEvent.id)
            .single();

          if (error) {
            console.error('Error fetching full event:', error);
          } else {
                  setEvent(normalizeEvent(data));
                console.log('🔎 normalized event (externalEvent flow):', {
                  id: data?.id,
                  host_id: data?.host_id ?? data?.user_id,
                  user_id: data?.user_id,
                });
          }
          setLoading(false);
        };

        fetchFullEvent();
        return;
      }


      const fetchEvent = async () => {
        const { data, error } = await supabase
          .from('hosting')
          .select('*')
          .eq('id', eventIdFromUrl)
          .single();

        if (error) {
          console.error('Error fetching event:', error);
        } else {
          console.log("📦 Fetched event from Supabase:", data);
          console.log("🧩 host_id from Supabase result:", data?.host_id);
          console.log("🧑‍🚀 user.id:", user?.id);

             setEvent(normalizeEvent(data));
            console.log('🔎 normalized event (URL flow):', {
              id: data?.id,
              host_id: data?.host_id ?? data?.user_id,
              user_id: data?.user_id,
            });
        }

        setLoading(false);
      };

      if (eventIdFromUrl) {
        fetchEvent();
      }
    }, [externalEvent, eventIdFromUrl]);



  useEffect(() => {
    const determineRole = async () => {
      if (!user || !event) return;

      if (user.id === event.host_id) {
        setViewerRole('host');
        return;
      }

      const { data: guestEntry, error } = await supabase
        .from('guests')
        .select('id')
        .eq('event_id', event.id)
        .eq('guest_id', user.id)
        .single();

      if (guestEntry) {
        setViewerRole('attendee');
      } else {
        setViewerRole(null);
      }
    };

    determineRole();
  }, [user, event]);

  useEffect(() => {
  const fetchJoinRequestCount = async () => {
    if (!event || !user || user.id !== event.host_id) return;

    const { count, error } = await supabase
      .from('event_requests')
      .select('*', { count: 'exact', head: true })
      .eq('event_id', event.id)
      .eq('status', 'pending');

    if (error) {
      console.error('❌ Error fetching join request count:', error);
    } else {
      setJoinRequestCount(count ?? 0);
    }
  };

  fetchJoinRequestCount();
}, [event, user]);


  useEffect(() => {
  const fetchJoinRequests = async () => {
    if (!event || !user) return;

    const { data, error } = await supabase
      .from('event_requests')
      .select('*')
      .eq('event_id', event.id);

    if (error) {
      console.error('Error fetching join requests:', error);
    } else {
      setJoinRequests(data || []);
      setHasNewJoinRequests(data && data.length > 0); // Simplified — we'll add "seen" logic later
    }
  };

  if (user?.id === event?.host_id) {
    fetchJoinRequests();
  }
}, [event, user]);

        console.log("👤 Logged in user:", user?.id);
        console.log("🎟️ Event host ID:", event?.host_id);
        console.log("🛂 isOwner result:", isOwner);
        console.log("👀 Passport context:", { user, profile });

    if (passportLoading) return null;

    if (!user) {
      console.warn("⚠️ EventViewer loaded without an authenticated user – treating as guest.");
    }


    if (loading) return <div className="eventviewer-loading">Loading event...</div>;
    if (!event) return <div className="eventviewer-error">Event not found.</div>;



  return (
    <div className="eventviewer-container">
      
<div className="eventviewer-title-row">
  <h1 className="eventviewer-title">{event.event_name}</h1>

</div>

      <div className="eventviewer-layout">
        {/* Left Side */}
      <div className="viewer-left">
       <div className="image-wrapper" style={{ position: 'relative' }}>
        <img
          src={event.event_image}
          alt={event.event_name}
          className="eventviewer-image"
        />
      </div>


        {/* Add back the Event Details header */}
        <h3><u>Event Summary</u></h3>

        {/* Two-column event details */}
        <div className="static-details two-column">
          <div className="column-left">
            <p><b>Description:</b><br />{event.description}</p>
            {['host', 'attendee'].includes(viewerRole) && (
              <p><b>Location:</b><br />{event.event_location}</p>
            )}
            <p>
                <b>Date:</b><br />
                {event.event_date && !isNaN(new Date(event.event_date))
                  ? new Date(event.event_date).toLocaleDateString(undefined, {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })
                  : 'TBD'}
              </p>
            <p><b>Weather:</b><br /><a href={event.weather_link}>{event.weather_link}</a></p>
            <p><b>What to Bring:</b><br />{event.what_to_bring}</p>
          </div>
          <div className="column-right">
            <p>
              <b>Event Hyperlinks:</b><br />
              {Array.isArray(event.event_link) && event.event_link.length > 0 ? (
                <ul className="link-list">
                  {event.event_link.map((link, idx) => (
                    <li key={idx}>
                      <a href={link.url} target="_blank" rel="noopener noreferrer" title={link.url}>
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <span style={{ color: '#666', fontStyle: 'italic' }}>Links TBD</span>
              )}
            </p>


            {['host', 'attendee'].includes(viewerRole) ? (
                <p><b>Moderator Contact:</b><br />{event.moderator_contact}</p>
              ) : (
                <p>
                  <b>Interested?</b><br />
                  <button onClick={() => setShowContactModal(true)} style={{ marginTop: '6px' }}>
                    Contact the Moderator
                  </button>
                </p>
              )}

                  {event.custom_field_1 && (
                    <p>
                      <b>{event.custom_field_1_label || 'Custom Field 1'}:</b><br />
                      {event.custom_field_1}
                    </p>
                  )}

                  {event.custom_field_2 && (
                    <p>
                      <b>{event.custom_field_2_label || 'Custom Field 2'}:</b><br />
                      {event.custom_field_2}
                    </p>
                  )}
          </div>
        </div>
      </div>


    {/* Right Side */}
    <div className="viewer-right">
    <div className="viewer-details-box">
          <div className="viewer-details-box-header">
          <div className="viewer-details-title">Event Details</div>
          {['host', 'attendee'].includes(viewerRole) && event.vrc && (
              <span className="vrc-code-display">VRC: {event.vrc}</span>
            )}

      </div>

    {['host', 'attendee'].includes(viewerRole) && (
      <div className="floating-icons-viewer">
        
        {viewerRole === 'attendee' && (<button className="topbar-icon-button" title="Respond to RSVP" onClick={() => setShowRSVPModal(true)}><RsvpIcon size={28} />
          </button>
        )}

      {(isOwner || event.is_public) && (
        <button
          className="topbar-icon-button"
          title="Join Requests"
          onClick={() => setShowJoinRequestModal(true)}
          style={{ position: 'relative' }}
        >
          <RequestsIcon size={28} />
            {joinRequestCount > 0 && (
              <span className="notification-badge">{joinRequestCount}</span>
            )}
        </button>
      )}

        <button className="topbar-icon-button" title="Dashboard" onClick={() => navigate('/dashboard')}>
          <DashboardIcon size={28} />
        </button>

        {event.allow_guest_invites && (
          <button
            className="topbar-icon-button"
            title="Show QR Code"
            onClick={() => setShowQRModal(true)}
          >
            <QRCodeIcon size={28} />
          </button>
        )}

        {isOwner && (<button className="topbar-icon-button" title="Edit Event" onClick={() => navigate(`/event/${event.id}/edit`)}>
            <EditEventIcon size={28} />
          </button>
        )}

        <button className="topbar-icon-button" title="Guest List" onClick={() => setShowGuestTable(true)}>
          <GuestListIcon size={28} />
        </button>

        <button className="topbar-icon-button" title="Settings" onClick={() => navigate('/settings')}>
          <SettingsIcon size={28} />
        </button>

        <button className="topbar-icon-button" title="Ask Buddy" onClick={() => alert("🤖 Buddy is coming soon! Stay tuned.")}>
          <BuddyIcon size={28} />
        </button>
      </div>
    )}

      {event.description && event.description.trim() !== '' ? (
        <p className="eventviewer-description">{event.description}</p>
      ) : (
        <p className="eventviewer-placeholder">Additional event details here...</p>
      )}
    </div>

    <div className="viewer-chat-box">
      <div className="viewer-details-box-header">
        <div className="viewer-details-title">Group Chat</div>
      </div>

      {isLoggedIn ? (
        <EventChat eventId={event.id} />
      ) : (
        <div className="eventchat-placeholder">
          <div className="eventchat-message-row">
            <span>💬 Become a member to see the chat room</span>
            <button
              className="join-now-button"
              onClick={() => navigate('/login?mode=signup')}
            >
              Join Now
            </button>
          </div>
        </div>
      )}
    </div>



    {isOwner && (
      <div className="viewer-button-row">
        {/* Owner-only actions moved to floating icons */}
      </div>
    )}

    </div>
    </div>
        {showQRModal && (
          <div className="qr-popup-overlay" onClick={() => setShowQRModal(false)}>
            <div className="qr-popup-content" onClick={(e) => e.stopPropagation()}>
              <QRCodeSVG value={`${window.location.origin}/invite/${qrToken}`} size={220} />
              <div style={{ marginTop: '10px', fontSize: '0.9rem' }}>{event.event_name}</div>
              <button onClick={() => setShowQRModal(false)} style={{ marginTop: '10px' }}>
                Close
              </button>
            </div>
          </div>
        )}
        {['host', 'attendee'].includes(viewerRole) && user && showGuestTable && (
          <GuestTable
            eventId={event.id}
            eventTitle={event.event_name}
            vrc={event.vrc}
            viewerRole={viewerRole}
            onClose={() => setShowGuestTable(false)}
            user={user}
            profile={profile}
          />

        )}
        {showRSVPModal && (
          <div className="qr-popup-overlay" onClick={() => setShowRSVPModal(false)}>
            <div className="qr-popup-content" onClick={(e) => e.stopPropagation()}>
              <RSVPBlock eventId={event.id} userId={user.id} />
              <button onClick={() => setShowRSVPModal(false)} style={{ marginTop: '10px' }}>
                Close
              </button>
            </div>
          </div>
        )}



    {showJoinRequestModal && (
      <>
        <div className="join-request-modal-overlay" onClick={() => setShowJoinRequestModal(false)}>
          <div className="join-request-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Join Requests</h3>
            {joinRequests.length === 0 ? (
              <p>No join requests yet.</p>
            ) : (
              joinRequests.map((req, index) => {
                const isIgnored = req.__status === 'ignored';
                const firstName = req.name?.split(' ')[0] || 'User';

                return (
                  <div key={index} className="join-request-item request-two-column">
                    <div className="request-left">
                      <p style={{ whiteSpace: 'pre-line', fontWeight: 'bold', textAlign: 'center' }}>
                        {(req.name || '—').split(' ').join('\n')}
                      </p>

                      {!isIgnored && (
                        <>
                          <div className="request-buttons" style={{ display: 'flex', gap: '4px', marginTop: '8px' }}>
                            <button
                              className="ignore-button"
                              onClick={() => {
                                setJoinRequests(prev =>
                                  prev.map(r => r.id === req.id ? { ...r, __status: 'ignored' } : r)
                                );
                              }}
                              title="Ignore this request"
                            >
                              <IgnoreIcon size={20} />
                            </button>

                            <button
                              className="add-button"
                              onClick={() => {
                                setSelectedRequestForSidebar(selectedRequestForSidebar?.id === req.id ? null : req);
                              }}
                              title="Add as guest"
                            >
                              <SmerkIcon size={20} />
                            </button>
                          </div>

                          {selectedRequestForSidebar?.id === req.id && (
                            <input
                              type="text"
                              className="expanding-passphrase-input show"
                              placeholder="Enter passphrase"
                              value={guestPassphrases[req.id] || ''}
                              onChange={(e) =>
                                setGuestPassphrases(prev => ({
                                  ...prev,
                                  [req.id]: e.target.value,
                                }))
                              }
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  handleApproveAndAddGuest(req);
                                  setSelectedRequestForSidebar(null);
                                }
                              }}
                              style={{ marginTop: '10px' }}
                            />
                          )}
                        </>
                      )}
                    </div>

                    <div className="request-right">
                      {isIgnored ? (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
                          <button
                            className="ignore-button"
                            title="Undo ignore"
                            onClick={() => {
                              setJoinRequests(prev =>
                                prev.map(r => r.id === req.id ? { ...r, __status: null } : r)
                              );
                            }}
                          >
                            <IgnoreIcon size={20} />
                          </button>
                          <span style={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Ignored</span>
                        </div>
                      ) : (
                        <>
                          <div style={{ marginBottom: '6px' }}>
                          {req.status === 'approved' && <span className="status-badge approved">✅ Approved</span>}
                          {req.email_sent && <span className="status-badge emailed">📧 Emailed</span>}
                          {req.__status === 'ignored' && <span className="status-badge ignored">🚫 Ignored</span>}
                        </div>
                          
                          {req.social_contact && (
                            <p><strong>Socials:</strong> {req.social_contact}</p>
                          )}
                          {req.phone && <p><strong>Phone:</strong> {req.phone}</p>}
                          {req.email && <p><strong>Email:</strong> {req.email}</p>}
                          {req.message && <p><strong>Message:</strong> {req.message}</p>}
                        </>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        <div className={`sidebar-slide ${selectedRequestForSidebar ? 'open' : ''}`}>
          <h3>Assign Passphrase</h3>

          {selectedRequestForSidebar && (
            <>
              <p><strong>Name:</strong> {selectedRequestForSidebar.name}</p>

              <input
                type="text"
                placeholder="Passphrase"
                value={guestPassphrases[selectedRequestForSidebar.id] || ''}
                onChange={(e) =>
                  setGuestPassphrases(prev => ({
                    ...prev,
                    [selectedRequestForSidebar.id]: e.target.value
                  }))
                }
                style={{ width: '100%', marginBottom: '1rem' }}
              />

              <button
                onClick={() => {
                  handleApproveAndAddGuest(selectedRequestForSidebar);
                  setSelectedRequestForSidebar(null);
                }}
                style={{ marginBottom: '1rem' }}
              >
                Save
              </button>

              <button onClick={() => setSelectedRequestForSidebar(null)}>
                Cancel
              </button>
            </>
          )}
        </div>
      </>
    )}

      {showContactModal && (
        <div className="modal-overlay" onClick={() => setShowContactModal(false)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '500px', width: '90%' }}
          >
            <h3 style={{ marginBottom: '1rem' }}>Send a Message to the Moderator</h3>

            <input
              type="text"
              placeholder="Name *"
              value={contactName}
              onChange={(e) => {
                setContactName(e.target.value);
                setErrors((prev) => ({ ...prev, name: false }));
              }}
              style={{
                width: '100%',
                marginBottom: '10px',
                borderColor: errors.name ? 'red' : '#ccc',
              }}
            />

            <input
              type="email"
              placeholder="Email *"
              value={contactInfo}
              onChange={(e) => {
                setContactInfo(e.target.value);
                setErrors((prev) => ({ ...prev, email: false }));
              }}
              style={{
                width: '100%',
                marginBottom: '10px',
                borderColor: errors.email ? 'red' : '#ccc',
              }}
            />

            <input
              type="text"
              placeholder="Phone Number (optional)"
              value={contactPhone}
              onChange={(e) => setContactPhone(e.target.value)}
              style={{ width: '100%', marginBottom: '10px' }}
            />

            <input
              type="text"
              placeholder="Optional social links (Instagram, etc.)"
              value={contactSocials}
              onChange={(e) => setContactSocials(e.target.value)}
              style={{ width: '100%', marginBottom: '10px' }}
            />

            <textarea
              placeholder="Your message *"
              value={contactMessage}
              onChange={(e) => {
                setContactMessage(e.target.value);
                setErrors((prev) => ({ ...prev, message: false }));
              }}
              rows={4}
              style={{
                width: '100%',
                marginBottom: '10px',
                borderColor: errors.message ? 'red' : '#ccc',
              }}
            />

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span
                className="modal-icon-button"
                onClick={() => setShowContactModal(false)}
                title="Cancel"
                role="button"
                tabIndex={0}
              >
                <CloseIcon size={22} color="#333" />
              </span>

              <span
                className="modal-icon-button"
                onClick={handleContactSubmit}
                title="Send"
                role="button"
                tabIndex={0}
              >
                <SendInviteIcon size={22} color="#333" />
              </span>
            </div>
          </div>
        </div>
      )}


  </div>

);
}